<template>
  <div
      v-if="preview && format"
      class="relative p-8px bg-neutral-100 rounded d-flex flex-column justify-content-between"
      style="max-height: 320px"
  >
    <div
        v-if="['application/pdf', 'pdf'].includes(format)"
        :class="`flex-grow-1 ${previewPdf ? 'pdf-preview' : '' }`"
    >
      <template v-if="previewPdf">
        <!--        <button class="btn btn-link" @click="openPreview" target="_blank">{{ $t("See Detail") }}</button>-->
        <object
            class="mt-1"
            :data="preview"
            type="application/pdf"
            width="100%"
            height="100%"
        ></object>
      </template>
      <button v-else class="btn btn-primary" @click="openPreview" style="width: 100%" target="_blank" v-b-tooltip.hover
              :title="originalFilename">{{ fileName }}
      </button>
    </div>
    <div class="relative" v-else>
      <template v-if="previewImage">
        <image-preview-modal v-bind="$props" :id="_uid"/>
        <b-img
            thumbnail
            fluid
            :style="imageStyle"
            :src="preview"
            @click="$bvModal.show(_uid)"
            role="button"
        >
        </b-img>
      </template>
      <button v-else class="btn btn-primary" @click="openPreview" style="width: 100%" target="_blank" v-b-tooltip.hover
              :title="originalFilename">{{ fileName }}
      </button>
    </div>
    <div class="d-flex justify-content-center">
      <b-button block variant="link" class="text-primary" @click="openPreview" target="_blank" v-b-tooltip.hover
                :title="originalFilename">{{ fileName }}</b-button>
    </div>
  </div>
</template>

<script>
import ImagePreviewModal from '@/components/modals/image-preview-modal';

export default {
  name: "attachment-preview",
  components: {
    ImagePreviewModal,
  },
  props: {
    preview: String,
    format: String,
    imageStyle: {
      type: String,
      default: "max-height: 260px; width: 100%; object-fit: contain;",
    },
    denyDelete: {
      type: Boolean,
      default: false,
    },
    previewPdf: {
      type: Boolean,
      default: true,
    },
    previewImage: {
      type: Boolean,
      default: true,
    },
    file: {
      default: undefined
    }
  },
  computed: {
    isBase64() {
      return this.preview.includes("data:");
    },
    originalFilename() {
      if (this.file?.file?.name) {
        return this.file?.file?.name
      }
      const filename = this.preview.split("/").pop();
      let cleanFilename = filename.split("?")[0];
      return cleanFilename;
    },
    fileName() {
      const maxLength = 24;
      let cleanFilename = this.originalFilename;
      if (cleanFilename.length > maxLength) {
        cleanFilename = cleanFilename.slice(0, maxLength) + '...';
      }
      return cleanFilename;
    }
  },
  methods: {
    openPreview() {
      if (!this.isBase64) {
        window.open(this.preview, "_blank");
      }
      let [header, base64data] = this.preview.split(",");
      let mime = header.match(/:(.*?);/)[1];
      let blob = new Blob(
          [
            new Uint8Array(
                atob(base64data)
                    .split("")
                    .map((c) => c.charCodeAt(0))
            ),
          ],
          {type: mime}
      );
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
      }
      this.objectUrl = URL.createObjectURL(blob);
      open(this.objectUrl);
    },
  },
};
</script>

<style scoped lang="scss">
.button-close {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
}

.pdf-preview {
  .button-close {
    top: 24px;
    right: -10px;
  }
  height: 320px;
}
</style>